import AboutRoutes from './about'

import ClientRecords from '@/pages/client/pages/records'
import ClientEvents from '@/pages/client/pages/events'
import ClientAbout from '@/pages/client/pages/about'
import ClientAccountant from '@/pages/client/pages/accountant'
import ClientAccountantLegacy from '@/pages/client/pages/legacy_accountant'
// import ClientLibrary from '@/pages/client/pages/library'
import ClientApplications from '@/pages/client/pages/applications'
import ClientBox from '@/pages/client/pages/box'

const ROOT = ''
export default {
  routes: [
    {
      path: `${ROOT}records`,
      name: 'ClientRecords',
      meta: {
        group: 'client',
        requireAuth: true,
        icon: {
          default: 'fal fa-clock',
          active: 'fa-clock'
        },
        label: '対応履歴',
        permit: 'records'
      },
      component: ClientRecords
    },
    {
      path: `${ROOT}about`,
      name: 'ClientAbout',
      meta: {
        group: 'client',
        requireAuth: true,
        icon: {
          default: 'fal fa-user',
          active: 'fa-user'
        },
        label: '顧客情報',
        permit: 'about'
      },
      component: ClientAbout,
      redirect: { name: 'ClientAboutBasic' },
      children: AboutRoutes.routes
    },
    {
      path: `${ROOT}accountant`,
      name: 'clientAccountantLegacy',
      meta: {
        group: 'client',
        requireAuth: true,
        icon: {
          default: 'fal fa-file-invoice-dollar',
          active: 'fa-file-invoice-dollar'
        },
        label: '会計',
        permit: 'cbook'
      },
      component: ClientAccountantLegacy
    },
    {
      path: `${ROOT}accountant_dev`,
      name: 'clientAccountant',
      meta: {
        group: 'client',
        requireAuth: true,
        icon: {
          default: 'fal fa-file-invoice-dollar',
          active: 'fa-file-invoice-dollar'
        },
        label: '会計（開発）',
        permit: 'cbook_dev'
      },
      component: ClientAccountant
    },
    // {
    //   path: `${ROOT}library`,
    //   name: 'clientLibrary',
    //   meta: {
    //     group: 'client',
    //     requireAuth: true,
    //     icon: {
    //       default: ['fal', 'books'],
    //       active: ['fas', 'books']
    //     },
    //     label: '旧ライブラリ',
    //     permit: 'library'
    //   },
    //   component: ClientLibrary
    // },
    {
      path: `${ROOT}box`,
      name: 'clientBox',
      meta: {
        group: 'client',
        requireAuth: true,
        icon: {
          default: 'fal fa-cloud',
          active: 'fa-cloud'
        },
        label: 'ライブラリ',
        permit: 'library'
      },
      component: ClientBox
    },
    {
      path: `${ROOT}applications`,
      name: 'clientApplications',
      meta: {
        group: 'client',
        requireAuth: true,
        icon: {
          default: 'fal fa-file-signature',
          active: 'fa-file-signature'
        },
        label: '申込',
        permit: 'applications'
      },
      component: ClientApplications
    },
    {
      path: `${ROOT}events`,
      name: 'ClientEvents',
      meta: {
        group: 'client',
        requireAuth: true,
        icon: {
          default: 'fal fa-bell',
          active: 'fa-bell'
        },
        label: '予定一覧',
        permit: 'events'
      },
      component: ClientEvents
    }
  ]
}
